import { Container } from '@mui/material'
import clsx from 'clsx'
import React from 'react'

import { useScreenSize } from '@src/hooks'

import styles from './styles.module.scss'
import { UContainerProps } from './type'

export const UContainer = ({ children, maxWidth = 'lg' }: UContainerProps) => {
  const { isUnderMdSize } = useScreenSize()
  return (
    <Container maxWidth={maxWidth} className={isUnderMdSize ? 'p-0' : ''}>
      <div className={clsx(styles['container'])}>{children}</div>
    </Container>
  )
}
